var _global = typeof window !== 'undefined' ? window : typeof global !== 'undefined' ? global : typeof self !== 'undefined' ? self : {};
_global.SENTRY_RELEASE = {
  id: "EBIg6IWA2AihYzpEaBbr8lbKnf3pJZ8q"
};